<div class="notes-content">{{config.data?.notes}}</div>
